import { render, staticRenderFns } from "./InstantPayout.vue?vue&type=template&id=71326fad&"
import script from "./InstantPayout.vue?vue&type=script&lang=js&"
export * from "./InstantPayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports